module.exports = __webpack_public_path__ + "static/media/tick.5e3488ec.svg";